import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'src/app/core/dialog.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { Unpaid, UnpaidStatus } from 'src/app/core/unpaid.service';
import { UtilsService } from 'src/app/core/utils.service';
import { UNPAID_TABLE_COLUMNS } from 'src/app/shared/constants/operationals';
import { UnpaidSetNoteDialogComponent } from 'src/app/unpaid/unpaid-set-note-dialog/unpaid-set-note-dialog.component';

@Component({
  selector: 'app-company-details-unpaid-data-table',
  templateUrl: './company-details-unpaid-data-table.component.html',
  styleUrls: ['./company-details-unpaid-data-table.component.scss'],
})
export class CompanyDetailsUnpaidDataTableComponent {
  @Input() unpaid: Unpaid[] = [];
  @Output() scrolledToEnd: EventEmitter<void> = new EventEmitter<void>();
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  displayed_columns: string[] = UNPAID_TABLE_COLUMNS;

  constructor(
    private navigation_service: NavigationService,
    private dialog_service: DialogService,
    private utils_service: UtilsService,
    private error_service: ErrorService,
  ) {}

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const end_offset = 200;
    if (element) {
      if (element.offsetHeight + element.scrollTop >= element.scrollHeight - end_offset) {
        this.scrolledToEnd.emit();
      }
    }
  }

  onSetNoteClick(unpaid: Unpaid) {
    this.dialog_service
      .openDialog(UnpaidSetNoteDialogComponent, { unpaid })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  getCurrencyLabel(currency: string): string {
    return this.utils_service.getCurrencyLabelFromString(currency);
  }

  getStepStatusClass(status: UnpaidStatus): string {
    return this.utils_service.getUnpaidStatusClass(status);
  }

  getStepStatusLabel(status?: UnpaidStatus): string {
    return this.utils_service.getUnpaidStatusLabel(status);
  }

  daysFromUnpaid(unpaid: Unpaid): number {
    const unpaid_from_date = new Date(unpaid.created_at).getTime();
    const end_date = unpaid.recovered_at ? new Date(unpaid.recovered_at).getTime() : Date.now();
    const difference = end_date - unpaid_from_date;
    return Math.abs(Math.round(difference / (24 * 60 * 60 * 1000)));
  }

  getFullName(unpaid: Unpaid): string {
    return `${unpaid.buyer_firstname} ${unpaid.buyer_lastname}`;
  }
}
